import { Button } from '@wot/components';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import plansApi from '../../../api/plans';
import { LOADING } from '../../../assets/animated';
import { TableBody, TableHeading, TableHeadingCol, TableRow } from '../../../components/Table';
import { LPlan } from '../../../interfaces/Plan';
import AddClasses from './components/AddClasses';
import { PlanCard } from './components/PlanCard';
import { TableRowItem } from './components/TableRowItem';

export default function ViewPlan() {
  const [plan, setPlan] = useState<LPlan>();
  const { plan_id } = useParams();

  useEffect(() => {
    if (!plan_id) {
      return;
    }
    plansApi
      .getById(plan_id)
      .then((res) => {
        if (res.data) {
          setPlan(res.data[0]);
        }
      })
      .catch((err) => err);
  }, [plan_id]);

  if (!plan) {
    return <p>Loading...</p>;
  }
  return <PlanDetails plan={plan} setPlan={setPlan} />;
}

export function PlanDetails({ plan, setPlan }: { plan: LPlan; setPlan: any }) {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const updateChangeRequest = (status: 'pending' | 'approved' | 'rejected') => {
    setLoading(true);
    plansApi
      .handleChangeRequest({
        _id: plan._id,
        status: status
      })
      .then((res) => {
        setLoading(false);
        //update state so that it takes the admin to the assign a trainer component instead of the details component
        // dispatch(getPlans());
        if (res.data) {
          if (status === 'approved') {
            setPlan({
              ...plan,
              changeRequest: {
                ...plan.changeRequest,
                status: 'approved'
              }
            });
            toast.success('Change Request Accepted successfully! Assign a new trainer to proceed');
          } else {
            setPlan({
              ...plan,
              changeRequest: {
                ...plan.changeRequest,
                status: 'rejected'
              }
            });
            toast.success('Change Request Declined!');
          }
          navigate(`/plan-management/bookings/${plan._id}`, { replace: true });
          return;
        }
      })
      .catch(() => setLoading(false));
  };

  return (
    <div className="h-full w-full p-4">
      <h1 className="text-xl font-bold">Plan Details</h1>
      <div className="my-5">
        <table className="table-fixed min-w-full">
          <TableHeading>
            <TableRow>
              <TableHeadingCol label="Date" />
              <TableHeadingCol label="Req ID" />
              <TableHeadingCol label="NAME" />
              <TableHeadingCol label="EMAIL" />
              <TableHeadingCol label="PHONE NO." />
              <TableHeadingCol label="CATEGORY" />
              <TableHeadingCol label="STATUS" />
            </TableRow>
          </TableHeading>
          <TableBody>
            <>
              <TableRow>
                <>
                  <TableRowItem setPlan={setPlan} navigation={false} plan={plan} />
                </>
              </TableRow>
            </>
          </TableBody>
        </table>
      </div>
      <PlanCard plan={plan} setPlan={setPlan} setShowPopup={setShowPopup} />
      {plan.status !== 'cancelled' && plan.changeRequest?.status === 'pending' && (
        <div className="w-full rounded-xl">
          <div className="w-full my-10 p-6 bg-neutralBlue2 rounded-xl">
            <h3 className="text-md py-2 font-semibold">Reason for Tutor Change</h3>
            <p className="text-sm">{plan.changeRequest.reason}</p>
          </div>
          {loading ? (
            <div className="max-w-sm w-full mx-auto pt-5 flex gap-4 items-center justify-center">
              <img src={LOADING} className="w-10 h-10" />
            </div>
          ) : (
            <div className="max-w-sm w-full mx-auto pt-5 flex gap-4 items-center justify-center">
              <Button
                type="s-outlined"
                text={'Decline Request'}
                onClick={() => {
                  updateChangeRequest('rejected');
                }}
              />
              <Button
                type="primary"
                text={'Accept Request'}
                onClick={() => {
                  updateChangeRequest('approved');
                }}
              />
            </div>
          )}
        </div>
      )}
      {showPopup && <AddClasses setPlan={setPlan} plan={plan} setShowPopup={setShowPopup} />}
    </div>
  );
}
